import { useState } from 'react';
import { CornerProps } from '../CornerRadiusInput.types';

type UseLinkedModeParams = {
  initial: boolean;
  onChangeCallbacks: CornerProps['onChange'][];
  onInvalidCallbacks: CornerProps['onInvalid'][];
  onBlurCallbacks: (() => void)[];
};

const useLinkedMode = ({
  initial = true,
  onChangeCallbacks,
  onInvalidCallbacks,
  onBlurCallbacks,
}: UseLinkedModeParams): [
  {
    linkedOnChange: CornerProps['onChange'];
    linkedOnInvalid: CornerProps['onInvalid'];
    linkedOnBlur: () => void;
    isLinkingEnabled: boolean;
  },
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const [isLinkingEnabled, setLinking] = useState(initial);
  const [isDirty, setIsDirty] = useState(false);

  const linkedOnChange: CornerProps['onChange'] = (...args) => {
    onChangeCallbacks.forEach(onChange => onChange?.(...args));
    setIsDirty(true);
  };

  const linkedOnInvalid: CornerProps['onInvalid'] = (...args) => {
    onInvalidCallbacks.forEach(onInvalid => onInvalid?.(...args));
    setIsDirty(true);
  };

  const linkedOnBlur = () => {
    isDirty && onBlurCallbacks.forEach(onBlur => onBlur());

    setIsDirty(false);
  };

  return [
    {
      linkedOnChange,
      linkedOnInvalid,
      linkedOnBlur,
      isLinkingEnabled,
    },
    setLinking,
  ];
};

export { useLinkedMode };
